/**
 * Do not edit directly.
 * Please read about making changes: https://github.com/viewthespace/monorepo/blob/main/libs/style-dictionary/README.md#making-changes.
 */

export const COLOR_DEFAULT_PALETTE_PRIMARY_100 = "#f5f5ff";
export const COLOR_DEFAULT_PALETTE_PRIMARY_200 = "#EBEBFF";
export const COLOR_DEFAULT_PALETTE_PRIMARY_300 = "#CCCCFF";
export const COLOR_DEFAULT_PALETTE_PRIMARY_400 = "#AEA9FE";
export const COLOR_DEFAULT_PALETTE_PRIMARY_500 = "#887EFC";
export const COLOR_DEFAULT_PALETTE_PRIMARY_600 = "#6253da";
export const COLOR_DEFAULT_PALETTE_PRIMARY_700 = "#4837b9";
export const COLOR_DEFAULT_PALETTE_PRIMARY_800 = "#280f96";
export const COLOR_DEFAULT_PALETTE_PRIMARY_900 = "#130A76";
export const COLOR_DEFAULT_PALETTE_SECONDARY_100 = "#f5fcfc";
export const COLOR_DEFAULT_PALETTE_SECONDARY_200 = "#e7f8f8";
export const COLOR_DEFAULT_PALETTE_SECONDARY_300 = "#bfeded";
export const COLOR_DEFAULT_PALETTE_SECONDARY_400 = "#80dbdb";
export const COLOR_DEFAULT_PALETTE_SECONDARY_500 = "#60d2d2";
export const COLOR_DEFAULT_PALETTE_SECONDARY_600 = "#009696";
export const COLOR_DEFAULT_PALETTE_SECONDARY_700 = "#247f7e";
export const COLOR_DEFAULT_PALETTE_SECONDARY_800 = "#1c6363";
export const COLOR_DEFAULT_PALETTE_SECONDARY_900 = "#124040";